export const ServiceOptions = [
  { id: 1, title: 'General' },
  { id: 2, title: 'Contacts' },
  { id: 3, title: 'Policies' },
  { id: 4, title: 'Custom Fields' },
  { id: 5, title: 'Banking' },
  { id: 6, title: 'Divisions' },
  { id: 7, title: 'Payroll' },
  { id: 8, title: 'Contract' },
  { id: 9, title: 'Fees' },
  { id: 10, title: 'Benefits' }
];

export const RegardingOptions = [
  { id: 1, title: 'General' },
  { id: 2, title: 'Value' }
];

export const SearchableProperties = new Set([
  'addedById',
  'serviceId',
  'regardingId',
  'subject',
  'comment',
  'modifiedBy',
  'addedOn',
  'createdParty',
  'categoryId',
]);